module.exports = __webpack_public_path__ + "img/questionnaire-purple-circles.da0d8658.svg";